import { useTranslation } from '@whoop/i18n/lang/client';
import { Info } from 'ui/icons/icons/Toast/info';
export function BNPLCallout(): React.ReactNode {
  const {
    t
  } = useTranslation('cart');
  return <div data-testid='bnpl-callout' className='flex items-center justify-center gap-2 rounded-xl bg-gray-50 px-5 py-4' data-sentry-component="BNPLCallout" data-sentry-source-file="BNPLCallout.tsx">
      <div className='border-gray-b50 flex h-4 w-4 items-center justify-center rounded-full border'>
        <Info color='gray' data-sentry-element="Info" data-sentry-source-file="BNPLCallout.tsx" />
      </div>
      <p className='text-sm'>{t('BNPLCallout')}</p>
    </div>;
}